import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';


const transformMethods: any = [
    {
        method: "replace",
        template: "replace|{old_elem}|{new_elem}|",
        example: "Example, input value: '4x4' and rule: replace|x|-| returns output value: '4-4'."
    },
    {
        method: "remove",
        template: 'remove|{elem}|',
        example: "Example, input value: '103.2 mm' and rule: remove| mm| returns output value: '103.2'."
    },
    {
        method: "multiply",
        template: 'multiply|{number}|',
        example: "Example, input value: '14.056' and rule: multiply|100| returns output value: '1405.6'."
    },
    {
        method: "split",
        template: 'split|{divider}|{needed_part}|',
        example: "Example, input value: '1308 x 384 x 553' and rule: split| x|0| returns output value: '1308' (the 1st number of a value). split| x|1| returns output value: '384' (the 2nd number)"
    },
    {
        method: "append",
        template: 'append|{symbol}|{value}|',
        example: "Example, input value: '0.265' and rule: append| x |0.265| returns output value: '0.265 x 0.265' (if value = original value, use 'self')."
    },
    {
        method: "prepend",
        template: 'prepend|{value}|{symbol}|',
        example: "Example, input value: '3658' and rule: prepend|0| - | returns output value: '0 - 3658' (if value = original value, use 'self')."
    },
    {
        method: "numerize",
        template: 'numerize||',
        example: "Example, input value: '15.200' and rule: numerize|| returns output value: '15.2'"
    },
    {
        method: "strip",
        template: 'strip||',
        example: "Example, input value: ' Black ' (with odd spaces and tabs) and rule: strip|| returns output value: 'Black'"
    },
    {
        method: "round",
        template: 'round|{number}|',
        example: "Example, input value: '1.246731' and rule: round|2| returns output value: '1.25'"
    }
]



export default function DialogHowToTransform(props: any) {
    let {open, setOpen} = props

    function handleClose() {
        setOpen(false)
    }

    return (

        <Dialog open={open} onClose={handleClose}>
            <DialogTitle sx={{fontSize: "0.95rem", borderBottom: "1px #cccccc solid", paddingBottom: "10px", marginBottom: "10px"}}>Definition and examples of transformation methods</DialogTitle>

            <DialogContent>

                <DialogContentText style={{fontSize: '0.8rem'}}>

                    {transformMethods.map((item:any, index: number) => {
                        return (
                            <div key={index} style={{marginBottom: "12px"}}>
                                <strong>{item.method}</strong>&nbsp;–&nbsp;
                                <span>generic template:</span>
                                <mark>{item.template}</mark>
                                <br/>
                                {item.example}
                            </div>
                        )
                        })}

                </DialogContentText>

            </DialogContent>

            <DialogActions>
                <Button onClick={handleClose}>Close</Button>
            </DialogActions>

        </Dialog>
    );
}